import React from "react";
import { useTranslation } from "react-i18next";
import {
  ButtonSize,
  ButtonVariant,
} from "../../../../../../../../../components/button/types";
import Button from "../../../../../../../../../components/button";

const SuccessPage = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation("myArea");

  return (
    <div className="flex flex-col items-start justify-center h-full">
      <h2 className="font-bold mt-2">{t(`assessments.cv-check.success`)}</h2>
      <p className="mt-5 text-gray-700">
        {t(`assessments.cv-check.final-message`)}
      </p>
      <div
        className="w-full py-3 px-4 lg:py-0 lg:px-0 
  fixed bottom-0 left-0 bg-white 
  lg:relative lg:bottom-auto lg:left-auto lg:bg-transparent"
      >
        <Button
          onClick={onClose}
          className="w-full mt-6"
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SMALL}
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default SuccessPage;
